import React from 'react';
import CoinWallet from "../../Asset/productdetail/CoinWallet.png"
import Undo from  "../../Asset/productdetail/Undo.png"
import VeganFood from "../../Asset/productdetail/VeganFood.png"

const Descrption = ({datalist}) => {
  return (
    <div className='w-full py-8'>
      <div className='flex flex-col  bg-white p-8 rounded-3xl'>
       <span className='text-xl font-bold text-textColor'>Product Info</span> 
       <div className='flex flex-wrap text-textColor text-justify'>
        {datalist?.description
        }</div>
      </div>
      <div className='mt-10 grid lg:grid-cols-3 grid-cols-1 md:gap-4 lg:gap-10 xl:gap-24 '>
          <div className='flex justify-center items-center w-full bg-white  rounded-5xl py-2 lg:py-0'>
            <div className='w-5/6 flex gap-3 md:gap-20 lg:gap-5 xl:gap-10 2xl:gap-20 items-center'>
            <div className=' w-[100px]  lg:w-[120px] '>
              <img src={Undo} alt="undo" className='w-full object-cover'/>
            </div>
            <span className=' text-gray-600 font-semibold text-sm lg:text-base xl:text-lg'>No return is allowd for this product</span>
            </div>
          </div>
          <div className='flex gap-2 items-center justify-center w-full bg-white py-2 lg:py-5 rounded-5xl mt-3 md:mt-0'>
          <div className='w-5/6 flex gap-3 md:gap-20 lg:gap-5 xl:gap-10 2xl:gap-20 items-center'>
            <div className='w-[107px] lg:w-[140px]'>
              <img src={CoinWallet} alt="img" className='w-full object-cover'/>
            </div>
            <span className=' text-gray-600 font-semibold text-sm lg:text-base xl:text-lg'>Refund amount will be credited in wallet only</span>
            </div>
          </div>
          <div className='flex gap-2 items-center justify-center w-full bg-white py-2 lg:py-5 rounded-5xl mt-3 md:mt-0'>
          <div className='w-5/6 flex  gap-3 md:gap-20 lg:gap-5 xl:gap-10 2xl:gap-20 items-center'>
            <div div className='w-[100px] lg:w-[100px]'>
              <img src={VeganFood} alt="img" className='w-full object-cover'/>
            </div>
            <span className='text-sm lg:text-base xl:text-lg text-gray-600 font-semibold'>100% Surety for product is organic</span>
            </div>
          </div>
      </div>
    </div>
  )
}

export default Descrption
